<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '100%'"
      right
      fullscreen
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
          <div class="title">
            Depósito: <label class="primary--text">{{ id }}</label>
          </div>
        <div>
          <div>
            <v-row>
              <v-col cols="6">
                <v-card>
                  <v-card-text>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="title">
                          Subtotal:
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <div class="title text-right">
                            ${{ total | toFixNumber(2) | numberWithComma }}
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card>
                  <v-card-text>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="title">
                          Total:
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <div class="title text-right">
                            ${{ netAmount | toFixNumber(2) | numberWithComma }}
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title class="title">
                          Notas:
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <div class="title text-right">
                            {{ notes ? notes : 'Sin notas' }}
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-data-table
                    :loading-text="table.title"
                    :loading="table.loading"
                    :headers="table.headers"
                    :items="table.data"
                    :items-per-page="table.itemsPerPage"
                    :page="table.page"
                    group-by="restaurant">
                    <template v-slot:top>
                      <div class="pa-3 subtitle">
                        Órdenes de compra:
                      </div>
                    </template>
                    <template v-slot:group.header="{ group, items }" cols="5">
                      <td colspan="7">
                        {{ group }}
                      </td>
                      <td colspan="7">
                        Total {{ calculateTotal(items) | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </td>
                    </template>
                    <template v-slot:item.uuid="{ item }">
                      <a href="" @click.prevent="openDialog(item)">
                        {{ item.uuid }}
                      </a>
                    </template>
                    <template v-slot:item.createdAt = "{ item }">
                      <div class="caption">
                        <div>
                          {{ item.createdAt | toDate }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:item.total="{ item }">
                        {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div class="mb-2">
                        {{ statuses[item.status] }}
                      </div>
                    </template>
                    <template v-slot:item.folio="{ item }">
                      <div
                        v-for="(invoice, index) in item.invoices"
                        :key="`invoice-${index}`"
                        class="mb-2">
                        {{ invoice.folio ? invoice.folio : '' }}
                      </div>
                    </template>
                    <template v-slot:item.invoice="{ item }">
                      <div
                        v-for="(invoice, index) in item.invoices"
                        :key="`invoice-${index}`"
                        class="mb-2">
                        <a href="" @click.prevent="openDetail(invoice)"> {{ invoice.uuid }}</a>
                      </div>
                    </template>
                    <template v-slot:item.subtotal="{ item }">
                      <div>
                        {{ item.netTotal | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </div>
                    </template>
                    <template v-slot:item.taxes="{ item }">
                      <div>
                        {{ calculateTaxes(item) | toFixNumber(2) | numberWithComma | prefix('$') }}
                      </div>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>

    </v-navigation-drawer>

    <InvoiceViewer ref="invoiceViewer" />

    <detail-dialog
      :dialog="dialog"
      :order="order"
      v-on:update:order="order = $event"
      @close="closeDialog"/>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import DetailDialog from '@/screens/purchaseOrders/Detail'

export default {
  name: 'DepositDetail',
  components: {
    InvoiceViewer,
    DetailDialog
  },
  props: {
    deposit: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      provider: {
        name: '',
        taxId: '',
        bankAccount: {
          name: ''
        }
      },
      table: {
        title: this.$i18n.t('deposits.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('deposits.detail.headers.order'), value: 'uuid', sortable: false },
          { text: this.$i18n.t('deposits.detail.headers.createdAt'), value: 'createdAt', sortable: false },
          { text: this.$i18n.t('deposits.detail.headers.restaurant'), value: 'restaurant' },
          { text: this.$i18n.t('deposits.detail.headers.status'), value: 'status', sortable: false },
          { text: this.$i18n.t('deposits.detail.headers.folio'), value: 'folio', sortable: false },
          { text: this.$i18n.t('deposits.detail.headers.invoice'), value: 'invoice', sortable: false },
          { text: this.$i18n.t('deposits.detail.headers.subtotal'), value: 'subtotal', sortable: false },
          { text: this.$i18n.t('deposits.detail.headers.taxes'), value: 'taxes', sortable: false },
          { text: this.$i18n.t('deposits.detail.headers.total'), value: 'total', sortable: false }
        ],
        total: 0,
        itemsPerPage: 300,
        page: 1
      },
      statuses: {
        sent: 'Nueva orden',
        confirmed: 'Confirmada',
        canceled: 'Cancelada',
        invoiced: 'Facturada',
        invalid: 'Factura no coincide',
        received: 'Entregada',
        pending_payment: 'Pendiente de pago',
        paid: 'Cobrada'
      },
      id: '',
      notes: '',
      netAmount: 0,
      total: 0,
      order: {},
      dialog: false
    }
  },
  watch: {
    async deposit (id) {
      await this.load(id)
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.isOpen = false
    },
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    },
    async load (id) {
      this.table.loading = true
      const params = {}
      if (['manager'].includes(this.$is())) {
        params.restaurant = this.$store.state.currentRestaurant.data._id
      }
      try {
        const response = await this.$api.get(`/v1/deposits/${id}`, params)
        response.orders = response.orders.map(order => ({
          ...order,
          restaurant: order.restaurant.name
        }))
        this.provider = response.provider
        this.id = response._id
        this.total = response.amount
        this.notes = response.notes
        this.netAmount = response.netAmount
        this.table.data = response.orders
        this.table.total = response.orders.length
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    async openDetail (item) {
      if (item) {
        await this.$refs.invoiceViewer.open(item)
      }
    },
    calculateTotal (items) {
      return items.reduce((acc, item) => acc + item.total, 0)
    },
    openDialog (item) {
      this.order = item
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
      this.order = {}
    },
    calculateTaxes (order) {
      const ieps = order.products.reduce((acc, product) => {
        const iepsTaxes = product.taxes.filter(tax => tax.satCode === '003' && tax.base > 0)
        const hasBaseAmount = (iepsTaxes || []).every(tax => tax.baseAmount && tax.baseAmount >= 0)
        if (hasBaseAmount) {
          const taxesAmount = iepsTaxes.reduce((acc, tax) => {
            const base = tax.isQuota ? tax.base : (tax.base / 100)
            return acc + (tax.baseAmount * base)
          }, 0)
          return taxesAmount
        }
        const ieps = product.taxes.find(tax => tax.satCode === '003' && tax.base > 0)
        const amount = product.amount - (product.discount || 0)
        acc = acc + (ieps ? (ieps.base / 100) * amount * product.quantityConfirmed : 0)
        return acc
      }, 0)

      return order.products.reduce((acc, product) => {
        const iva = product.taxes.find(tax => tax.satCode === '002' && tax.base > 0)
        acc = acc + (iva ? (iva.base / 100) * (product.amount + ieps) * product.quantityConfirmed : 0)
        return acc
      }, 0)
    }
  }
}
</script>
